// "It is better to have 100 functions operate on one data structure than to have 10 functions operate on 10 data structures." - Alan J. Perlis

import { Boat, BoatExtra, BoatImage } from "src/lib/types/boat"

const hasImages = (boat: Boat) => boat && Array.isArray(boat.images) && boat.images.length > 0

const imageHasURL = (img: BoatImage) => img && img.cardImageSrc && img.cardImageSrc !== ""

const imageByType = (boat: Boat, type: string) => {
  if (!boat) return null
  if (hasImages(boat)) {
    const img = boat.images.filter((i) => i.type === type)[0]
    if (imageHasURL(img)) {
      return img.cardImageSrc
    }
    return null
  }
  return null
}

const planImage = (boat: Boat) => imageByType(boat, "PLAN_IMAGE")

const mainImage = (boat: Boat) => imageByType(boat, "MAIN_IMAGE")

const nonPlanImages = (boat: Boat) => {
  if (hasImages(boat)) {
    const notMainOrPlan = boat.images
      .filter((i) => !["MAIN_IMAGE", "PLAN_IMAGE"].includes(i.type))
      .map((i) => i.cardImageSrc)
      .filter((ulr) => ulr) // removes null, undefined, etc
    const main = mainImage(boat)
    return [main, ...notMainOrPlan]
  }
  return []
}

const extrasNamingMap: [string[], string][] = [
  [["skipper", "captain"], "Skipper"],
  [["wifi"], "Wifi"],
  [["hostess", "host"], "Hostess"],
  [["cook", "chef"], "Chef"],
  [["tourist tax"], "Tourist Tax"],
  [["transfer"], "Transfer"],
  [["comfort"], "Comfort Package"],
  [["welcome"], "Welcome Kit"],
  [["outboard engine"], "Outboard Engine"],
  [["spinnaker"], "Spinnaker"],
  [["blister"], "Blister"],
  [["safety net"], "Safety Net"],
  [["end cleaning"], "End Cleaning"],
]

const truncateString = (str: string, num: number) => {
  if (str.length > num) {
    return str.slice(0, num) + "..."
  } else {
    return str
  }
}

const normalizeExtraName = (extra: BoatExtra): BoatExtra => {
  // TODO: This is too simplistic, further thinking required
  // const normName = extra.name.toLowerCase().replace(/\W/g, "")
  // for (const [kws, extraName] of extrasNamingMap) {
  //   if (kws.includes(normName)) {
  //     return { ...extra, name: extraName }
  //   }
  // }
  // return { ...extra, name: truncateString(extra.name, 25) }
  return { ...extra, name: extra.name }
}

const includedExtras = (extras: BoatExtra[]): BoatExtra[] => {
  return extras.filter((e) => e.price === 0).map(normalizeExtraName)
}

const obligatoryExtras = (extras: BoatExtra[]): BoatExtra[] => {
  return extras.filter((e) => e.obligatory).map(normalizeExtraName)
}

export { includedExtras, obligatoryExtras, planImage, mainImage, nonPlanImages }
